import { Form, Modal, ModalProps } from 'antd';
import React from 'react';
import InvoicingAverageTicketForm from './InvoicingAverageTicketForm';
import { ChartInvoicingAverageTicketFilterValues } from '..';

type Props = Omit<ModalProps, 'onOk'> & {
  handleOk: (values: ChartInvoicingAverageTicketFilterValues) => void;
};

const InvoicingAverageTicketModal: React.FC<Props> = ({
  open,
  onCancel,
  handleOk,
}) => {
  const [form] = Form.useForm<ChartInvoicingAverageTicketFilterValues>();
  const formValues = Form.useWatch([], form);

  return (
    <Modal
      title="Ticket Médio (Peças x Serviços)"
      open={open}
      onCancel={onCancel}
      width={600}
      onOk={async () => {
        try {
          await form.validateFields();
          handleOk({
            ...formValues,
            initialDate: formValues?.initialDate.startOf('day'),
            finalDate: formValues?.finalDate.endOf('day'),
          });
        } catch {}
      }}
      okText="Atualizar Gráfico"
    >
      <InvoicingAverageTicketForm form={form} />
    </Modal>
  );
};

export default InvoicingAverageTicketModal;
